import { MapAction, MapActionTypes } from './map.actions';
import { MapPosition } from '../models';

export interface MapState {
  [mapId: string]: MapPosition;
}

export const initialMapState: MapState = {};

export function mapReducer(state: MapState = initialMapState, action: MapAction): MapState {
  switch (action.type) {
    case MapActionTypes.SAVE_MAP_POSITION: {
      const mapPosition = state[action.mapId]
        ? <MapPosition>{
            ...state[action.mapId],
            ...action.position,
          }
        : <MapPosition>action.position;

      return {
        ...state,
        [action.mapId]: mapPosition,
      };
    }

    case MapActionTypes.CLEAR_MAP_POSITION: {
      return action.mapId
        ? {
            ...state,
            [action.mapId]: undefined,
          }
        : { ...initialMapState };
    }

    default:
      return state;
  }
}
